
import React, { useEffect, useState } from 'react';
import { fetchModules, fetchScreens, fetchScreenPermission1, insertScreenPermission } from '../../../utils/permissions';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
                    
const RoleBaseAccess = () => {
  const [modules, setModules] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);
  const [screens, setScreens] = useState([]);
  const [subScreens, setSubScreens] = useState({});
  const [expandedModules, setExpandedModules] = useState([]);
  const [selectedScreen, setSelectedScreen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [targetUserId, setTargetUserId] = useState('');
  const authState = useSelector((s) => s.auth);
  const currentUserId = authState?.auth?.ID || authState?.auth?.id || authState?.auth?.localId;

 useEffect(() => {
  async function load() {
    setLoading(true);

    const res = await fetchModules();
    

    if (res?.error) {
      swal('Error', res.error?.Message || res.error || 'Failed to load modules', 'error');
      setLoading(false);
      return;
    }

    let parsedData = null;

    try {
    
      parsedData = typeof res.data === "string" 
        ? JSON.parse(res.data) 
        : res.data;

    } catch (err) {
      console.error("JSON parse error", err);
    }

   

    const modulesArray = parsedData?.Table || [];

    

    setModules(Array.isArray(modulesArray) ? modulesArray : []);
    setLoading(false);
  }

  load();
}, []);

async function openModule(mod) {
  
  const id = mod?.ModuleID || mod?.ID || mod?.id;
  setSelectedModule(mod);
  setSelectedScreen(null);
  if (expandedModules.includes(id)) {
    setExpandedModules(expandedModules.filter(x => x !== id));
    return;
  }

  setExpandedModules([...expandedModules, id]);
  setLoading(true);

 
  const res = await fetchScreens(mod?.ModuleID || mod?.ID || mod?.moduleId);
  if (res?.error) {
    swal('Error', res.error?.Message || res.error || 'Failed to load screens', 'error');
    setLoading(false);
    return;
  }

  let parsedData = null;
  try {
    parsedData = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
  } catch (err) {
    console.error("JSON parse error", err);
  }

  const screensArray = parsedData?.Table || [];

  setSubScreens(prev => ({ ...prev, [id]: Array.isArray(screensArray) ? screensArray.map(s => ({ ...s, __perms: null })) : [] }));
  setLoading(false);
}

async function openScreen(screen) {
  setSelectedScreen(null);
  setLoading(true);
  const effectiveUserId = targetUserId || currentUserId;

  if (!effectiveUserId) {
    swal('Select user', 'Please enter Target UserID to load permissions', 'info');
    setLoading(false);
    return;
  }

  const permRes = await fetchScreenPermission1(screen?.ScreenCode || screen?.ScreenID, effectiveUserId);
  let parsedPerm = null;
  try {
    parsedPerm = typeof permRes?.data === "string" ? JSON.parse(permRes.data) : permRes;
  } catch (err) {
    console.error('perm parse error', err);
  }
  const table = parsedPerm?.Table || parsedPerm?.data?.Table || null;
 
  const permsList = Array.isArray(table) ? table : [];
  
  setSelectedScreen({ ...screen, __permsList: permsList });
  setLoading(false);
}

  async function togglePermission(screen, key, permRow) {
  const current = permRow?.[key] || false;
  const newVal = !current;

  
  if (selectedScreen && selectedScreen.__permsList) {
    setSelectedScreen(prev => ({
      ...prev,
      __permsList: prev.__permsList.map(p => ((p.UserID === (permRow.UserID || permRow.UserId)) ? { ...p, [key]: newVal } : p))
    }));
  }

  
  const modId = selectedModule?.ModuleID || selectedModule?.ID || selectedModule?.id;
  if (modId && subScreens[modId]) {
    setSubScreens(prev => ({
      ...prev,
      [modId]: prev[modId].map(s => (s.ScreenID === screen.ScreenID || s.ScreenCode === screen.ScreenCode) ? { ...s, __perms: { ...(s.__perms||{}), [key]: newVal } } : s)
    }));
  }

  const userIdForPayload = permRow?.UserID || permRow?.UserId || permRow?.User || targetUserId || currentUserId;
  const payload = {
    UserID: userIdForPayload,
    ScreenID: screen?.ScreenID || screen?.ID || screen?.screenId || screen?.ScreenCode,
    DisplayOK: (key === 'DisplayOK') ? newVal : (permRow?.DisplayOK || false),
    AddOK: (key === 'AddOK') ? newVal : (permRow?.AddOK || false),
    ChangeOK: (key === 'ChangeOK') ? newVal : (permRow?.ChangeOK || false),
    DeleteOK: (key === 'DeleteOK') ? newVal : (permRow?.DeleteOK || false),
    PrintOK: (key === 'PrintOK') ? newVal : (permRow?.PrintOK || false),
    CreatedByUser: currentUserId,
  };

  const res = await insertScreenPermission(payload);
  if (res?.error) {
    swal('Error', res.error?.Message || res.error || 'Failed to update permission', 'error');

  
    if (selectedScreen && selectedScreen.__permsList) {
      setSelectedScreen(prev => ({
        ...prev,
        __permsList: prev.__permsList.map(p => ((p.UserID === (permRow.UserID || permRow.UserId)) ? { ...p, [key]: current } : p))
      }));
    }

    if (modId && subScreens[modId]) {
      setSubScreens(prev => ({
        ...prev,
        [modId]: prev[modId].map(s => (s.ScreenID === screen.ScreenID || s.ScreenCode === screen.ScreenCode) ? { ...s, __perms: { ...(s.__perms||{}), [key]: current } } : s)
      }));
    }

    return;
  }

  swal('Saved', 'Permission updated', 'success');
  }

  return (
    <div className="row">
      <div className="col-md-3">
        <div className="card">
          <div className="card-body">
            <h5>Modules</h5>
            {loading && !modules.length && <p>Loading...</p>}
            <ul className="list-group">
              {modules.map((m) => {
                const id = m.ModuleID || m.ID || m.id;
                return (
                  <React.Fragment key={id}>
                    <li className={`list-group-item ${selectedModule && (selectedModule.ModuleID === m.ModuleID) ? 'active' : ''}`} style={{cursor:'pointer'}} onClick={() => openModule(m)}>
                      {m.ModuelName || m.ModuleName || m.Name || m.moduleName || m.Title}
                    </li>
                    {expandedModules.includes(id) && Array.isArray(subScreens[id]) && (
                      <ul className="list-group" style={{marginLeft:12,backgroundColor:'#e78f884d'  }}> 

                        {subScreens[id].map((s) => (
                          <li key={s.ScreenID || s.ID || s.screenId} className={`list-group-item`} style={{cursor:'pointer', fontSize:13}} onClick={() => openScreen(s)}>
                            {s.ScreenName || s.Name || s.ScreenCode || s.Title}
                          </li>
                        ))}
                      </ul>
                    )}
                  </React.Fragment>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      <div className="col-md-9">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Permissions {selectedModule ? `- ${selectedModule.ModuleName || selectedModule.Name || ''}` : ''}</h5>
              
            </div>

            <div style={{maxHeight: '60vh', overflowY: 'auto'}}>
              {selectedScreen ? (
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Username</th>
                      <th>Display</th>
                      <th>Add</th>
                      <th>Change</th>
                      <th>Delete</th>
                      <th>Print</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedScreen.__permsList && selectedScreen.__permsList.length > 0 ? (
                      selectedScreen.__permsList.map((perm) => (
                        <tr key={perm.UserID || perm.UserId || perm.ID || perm.UserName}>
                          <td>{perm.UserName || perm.Username || perm.UserID || perm.UserId || perm.Name}</td>
                          {['DisplayOK','AddOK','ChangeOK','DeleteOK','PrintOK'].map((k)=> (
                            <td key={k}>
                              <input type="checkbox" checked={!!perm?.[k]} onChange={()=>togglePermission(selectedScreen,k,perm)} />
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6}>No permission rows found for this screen.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) : (
                <p>{selectedModule ? 'Select a submodule to view/set permissions.' : 'Select a module to load submodules.'}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RoleBaseAccess;